import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useContextState } from '../../context/Context';
import LoginModal from '../modals/LoginModal';

interface Props {
    children: React.ReactNode;
}

/**
 * Wraps any route that requires authentication.
 * Renders a LoginModal instead of the page content when the user is not signed in.
 * This centralises auth-gating so individual pages don't need inline checks.
 */
const RequireAuth: React.FC<Props> = ({ children }) => {
    const { accountCTX } = useContextState();
    const { signedIn } = accountCTX;
    const navigate = useNavigate();

    if (!signedIn) {
        return (
            <LoginModal
                close={true}
                closeButton={() => navigate('/')}
                back={() => navigate('/')}
            />
        );
    }

    return <>{children}</>;
};

export default RequireAuth;
